export enum RfChannelAntennaDiversityMode {
	PredictiveDiversity = 'PREDICTIVE_DIVERSITY',
	SpatialDiversity = 'SPATIAL_DIVERSITY',
	TrueDigitalDiversity = 'TRUE_DIGITAL_DIVERSITY'
}
